import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  CoutSupplementaire,
  CoutSupplementaireResponse,
} from '../../types/coutSupplementaireTypes'
import {
  addCoutSupplementaireApi,
  deleteCoutSupplementaireApi,
  getCoutSupplementairebyIdApi,
  getCoutSupplementairesByActionIdApi,
  updateCoutSupplementaireApi,
} from '../../api/CoutSupplementaireApi'
import { parseCoutSupplementaireFloatFields } from '../../utils/parseFloatFields'
import { handleError } from '../../utils/errorHandler'

export const deleteCoutSupplementaire = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>(
  'coutSupplementaire/deleteCoutSupplementaire',
  async (CoutSupplementaireId, thunkAPI) => {
    try {
      await deleteCoutSupplementaireApi(CoutSupplementaireId)
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const addCoutSupplementaire = createAsyncThunk<
  CoutSupplementaire,
  CoutSupplementaire,
  { rejectValue: string }
>(
  'coutSupplementaire/addCoutSupplementaire',
  async (newCoutSupplementaire, thunkAPI) => {
    try {
      // Parse float fields before sending to API
      const parsedCoutSupplementaire = parseCoutSupplementaireFloatFields(
        newCoutSupplementaire
      )
      const response = await addCoutSupplementaireApi(parsedCoutSupplementaire)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getCoutSupplementairebyId = createAsyncThunk<
  CoutSupplementaire,
  string,
  { rejectValue: string }
>(
  'coutSupplementaire/getCoutSupplementairebyId',
  async (CoutSupplementaireId, thunkAPI) => {
    try {
      const response = await getCoutSupplementairebyIdApi(CoutSupplementaireId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const updateCoutSupplementaire = createAsyncThunk<
  CoutSupplementaire,
  { updatedCoutSupplementaire: CoutSupplementaire; _id: string },
  { rejectValue: string }
>(
  'coutSupplementaire/updateCoutSupplementaire',
  async ({ updatedCoutSupplementaire, _id }, thunkAPI) => {
    try {
      // Parse float fields before sending to API
      const parsedCoutSupplementaire = parseCoutSupplementaireFloatFields(
        updatedCoutSupplementaire
      )
      const response = await updateCoutSupplementaireApi(
        parsedCoutSupplementaire,
        _id
      )
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getCoutSupplementairesByActionId = createAsyncThunk<
  CoutSupplementaireResponse,
  string,
  { rejectValue: string }
>(
  'coutSupplementaire/getCoutSupplementairesByActionId',
  async (ActionId, thunkAPI) => {
    try {
      const response = await getCoutSupplementairesByActionIdApi(ActionId)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
